import moment from 'moment';
import { DefaultDateFormat } from './ResearchUIConstants';

export const breachOnFinish = (values) => {
    return values.map((i) => {
        if (i?.date) i.date = moment(i.date).format(DefaultDateFormat);
        if (i?.netskope_publish_date) i.netskope_publish_date = moment(i.netskope_publish_date).format(DefaultDateFormat);
        if (i?.public_disclosure_date) i.public_disclosure_date = moment(i.public_disclosure_date).format(DefaultDateFormat);
        i = breachDataCleanUp({ ...i });
        return i;
    });
};

const breachDataCleanUp = (breach) => {
    const replaceLetters = ["'"];
    replaceLetters.map((letter) => {
        if (breach?.name) breach.name = breach?.name.trim().replace(letter, '');
        if (breach?.media_links)
            breach.media_links = breach?.media_links.map((proof) => {
                if (proof?.source) proof.source = proof?.source.trim().replace(letter, '');
                if (proof?.url) proof.url = proof?.url.trim().replace(letter, '');
                return proof;
            });
    });
    return breach;
};

export const ResearchUISteps = {
    basicInfo: {
        step_id: 'basicInfo',
        title: 'Basic Info',
    },
    certification: {
        step_id: 'certification',
        category: ['certification', 'data_protection'],
        title: 'Certificate & Data Protection',
    },
    accessControl: {
        step_id: 'accessControl',
        category: ['access_control', 'audit'],
        title: 'Access Control',
    },
    disasterRecovery: {
        step_id: 'disasterRecovery',
        category: ['disaster_recovery', 'vulnerability'],
        title: 'Disaster Recovery & Vulnerability',
    },
    legal: {
        step_id: 'legal',
        category: ['legal_privacy_legal', 'legal_privacy_mobile', 'legal_privacy_browser'],
        title: 'Legal & Privacy',
    },
    gdpr: {
        step_id: 'gdpr',
        title: 'GDPR',
        category: ['gdpr'],
    },
    genAi: {
        step_id: 'genAi',
        title: 'Gen AI',
        category: ['gen_ai'],
    },
};
